import JoinProgramModal from './view';

export default JoinProgramModal;
